import { useState, useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import Routes from '../Routes'
import LoadingContent from "../component/loading/LoadingContent";
import ModalControl from '../component/popups/Index'
import Navbar from "../component/navbar/Index";
import Sidebar from '../component/sidebar/Index'
import ServiceAuth from '../service/Auth'
import Actions from "../redux/actions";

function App() {
  const [content, setContent] = useState(<LoadingContent />);
  const dispatch = useDispatch()
  const email = useSelector(state => state.acc.email)

  useEffect(() => {
    const init = async() =>{
      let session = await ServiceAuth.session()
      if(session){
        dispatch(Actions.acc.setAcc(session))
      }
    }

    init()
    setContent(<Routes />)
  }, [dispatch]);

  return (
    <>
      <div className="main">
        <div className="main__container">
          <Navbar />
          <div className="main__container-content">
            {/* {email ? (<Sidebar />) : <> </>} */}
            <div className="content">
              <div className="content__container">{content}</div>
            </div>
          </div>
        </div>
      </div>
      <ModalControl className="" set={1} />
      <ModalControl className="" set={2} />
    </>
  );
}

export default App;
